import React, { useEffect, useState, useRef } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import { isNil } from 'lodash';
import { Dropdown } from 'primereact/dropdown'
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';


import moment from 'moment';
import * as rdUri from 'helpers/Uri';
import * as rdEnum from 'helpers/enum';
import * as commonModel from 'model/ICommon';
import { IAppState } from 'model/IAppState';
import { useCountryState } from 'helpers/useCountryState';
import * as saveDialogViewModel from 'model/ISaveDialogViewModel';
import * as interestModel from 'model/IInterest';
import * as interestService from 'services/Interest';
import * as saveDialogHelper from 'businessHelpers/SaveDetailsStateHelper';
import IsNumberVerification from 'components/IsNumberVerification';

import PrivacyPolicyLink from 'components/PrivacyPolicyLink';
import PrivacyCollectionDialog from 'pages/Main/checkout/PrivacyCollectionDialog';


interface IRequestACallInputsProps {
    qrCode: string;
    afterSubmitSuccess?: () => void;
    afterSubmitFail?: () => void;

}

const RequestACallForm: React.FC<IRequestACallInputsProps> = ({ qrCode, afterSubmitSuccess, afterSubmitFail }) => {

    const countryState = useCountryState();

    const [countries, setCountries] = useState<commonModel.ICodeName[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<commonModel.ICodeName>({ code: "", name: "" });
    const [pageState, setPageState] = useState<saveDialogViewModel.SaveDetailsState>(saveDialogHelper.initPageState());
    const [savingStatus, setSavingStatus] = useState(rdEnum.enumProcessingStatus.Init);
    const [saveFailedMessage, setSaveFailedMessage] = useState("");

    const [isOverflown, setIsOverflown] = useState(false);
    const textAreaRef = useRef<any>(null);

    const checkOverflow = () => {
        const textarea = textAreaRef.current;

        if (textarea) {
            const rowHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 12);

            const maxVisibleHeight = rowHeight * 10;

            if (textarea?.scrollHeight > maxVisibleHeight) {
                setIsOverflown(true);
            } else {
                setIsOverflown(false);
            }
        }
    };

    const doGetCountry = async () => {
        let country = await countryState.getCountry();
        setCountries(country);
    }



    useEffect(() => {
        checkOverflow(); // Check on component mount

        doGetCountry();
    }, []);

    const onCountryChange = (e: any) => {
        setSelectedCountry(e.value);
        setPageState({
            ...pageState,
            invalidCountry: isNil(e.value)
        });
    }

    const validation = (): boolean => {
        let invalid = false;

        let invalidCountry = false;
        let invalidFirstname = false;
        let invalidLastname = false;
        let invalidEmail = false;
        let invalidConfirmEmail = false;
        let emailMismatch = false;
        let invalidMobile = false;
        let invalidMarketingComms = false;
        let invalidCheckPrivacy = false;

        const emailValidator = !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(pageState?.email);

        if (isNil(selectedCountry?.code) || selectedCountry?.code == "") {
            invalid = true;
            invalidCountry = true;
        }

        if (isNil(pageState.firstname) || pageState.firstname == "") {
            invalid = true;
            invalidFirstname = true;
        }
        if (isNil(pageState.lastname) || pageState.lastname == "") {
            invalid = true;
            invalidLastname = true;
        }
        if (isNil(pageState.email) || pageState.email == "" || emailValidator) {
            invalid = true;
            invalidEmail = true;
        }

        //if (isNil(pageState.confirmEmail) || pageState.confirmEmail == "" || emailValidator) {
        //    invalid = true;
        //    invalidConfirmEmail = true;
        //}
        //if (pageState.email != pageState.confirmEmail) {
        //    invalid = true;
        //    emailMismatch = true;
        //}
        if (isNil(pageState.mobile) || pageState.mobile == "" || pageState.mobile.length < 9 || pageState.mobile.length > 13) {
            invalid = true;
            invalidMobile = true;
        }
        //if (!pageState.checkMarketingComms) {
        //    invalid = true;
        //    invalidMarketingComms = true;
        //}
        if (!pageState.checkPrivacy) {
            invalid = true;
            invalidCheckPrivacy = true;
        }

        let newPageState = {
            ...pageState,
            invalidCountry: invalidCountry,
            invalidFirstname: invalidFirstname,
            invalidLastname: invalidLastname,
            invalidEmail: invalidEmail,
            invalidConfirmEmail: invalidConfirmEmail,
            emailMismatch: emailMismatch,
            invalidMobile: invalidMobile,
            invalidCheckMarketingComms: invalidMarketingComms,
            invalidCheckPrivacy: invalidCheckPrivacy
        };
        setPageState(newPageState);

        return invalid;
    }

    const handleSubmit = async () => {

        let invalid = validation();
        if (invalid) return;

        let interestData: interestModel.IInterest = {
            Country: selectedCountry?.code || "",
            State: "",
            VariantName: null,
            VariantBasePrice: null,
            ExteriorName: null,
            ExteriorPrice: null,
            InteriorName: null,
            InteriorPrice: null,
            PaymentOption: null,
            Email: pageState.email,
            FirstName: pageState.firstname,
            LastName: pageState.lastname,
            Mobile: pageState.mobile,
            ABN: null,
            BusinessName: null,
            CustomerType: null,
            DeliveryAddress: null,
            DeliveryLocationState: null,
            DeliveryLocationSuburb: null,
            DeliveryLocationPostcode: null,
            DeliveryOption: null,
            EstDeliveryDate: null,
            PrivacyStatement: true,
            Marketing: pageState.checkMarketingComms,
            InterestType: rdEnum.enumInterestType.Save,
            Comments: pageState.comments,
            WebUniqueKey: null,
            Options: null,
            VehicleThumbnail: null,
            Source: rdEnum.enumInterestSource.RequestCall,
            UTMtag: qrCode
        };

        setSaveFailedMessage("");
        setSavingStatus(rdEnum.enumProcessingStatus.Processing);
        let response = await interestService.saveInterest(interestData, true);
        if (response.status) {
            setSavingStatus(rdEnum.enumProcessingStatus.Processed);
            if (afterSubmitSuccess) {
                afterSubmitSuccess();
            }
        }
        else {
            setSaveFailedMessage(response.message);
            setSavingStatus(rdEnum.enumProcessingStatus.Init);
            if (afterSubmitFail) {
                afterSubmitFail();
            }
        }

    }

    const submitButtonTemplate = () => {
        if (savingStatus == rdEnum.enumProcessingStatus.Processing) {
            return (
                <div className="button-wrapper">
                    <Button type="button" className='progress-btn' disabled={true} >
                        <ProgressSpinner
                            style={{ width: '16px', height: '16px' }}
                            strokeWidth="5"
                            animationDuration=".8s"
                        />
                    </Button>
                </div>
            );
        }
        else if (savingStatus == rdEnum.enumProcessingStatus.Init) {
            return (
                <div className="button-wrapper">
                    <Button
                        onClick={() => handleSubmit()} disabled={!pageState.checkPrivacy}
                        style={{ border: 'none', backgroundColor: !pageState.checkPrivacy ? '#CCCCCC' : '#282828' }}
                    >
                        <span style={{ color: !pageState.checkPrivacy ? '#707070' : '#fff' }}>SUBMIT</span>
                    </Button>
                </div>
            );
        }
        else if (savingStatus == rdEnum.enumProcessingStatus.Processed) {
            return (
                <div className='section-save-ack'>
                    <img className="image" src={`${rdUri.getCMSAssets()}/checkout/success-tick.svg`} />
                    <span className="success-message">We've received your request for support. The Cadillac sales team will reach out to you shortly.</span>
                </div>
            );
        }
    }

    return (
        

        <div className='request-a-call-container'>
            <div className="page-title">
                REQUEST A CALL
                    </div>
            <div className="page-desc">
                Complete the form below and a member of our Cadillac Sales team will be in touch shortly
                    </div>

            <div className='input-container'>

                <div className='input-item'>
                    <span className="wrapper-box">
                        <Dropdown
                            value={selectedCountry}
                            options={countries.length > 0 ? countries : [{ name: "Loading...", value: "" }]}
                            onChange={(e) => onCountryChange(e)}
                            className='global-location-dropdown'
                            optionLabel="name"
                            placeholder=""
                        />
                        <label className={selectedCountry?.code ? 'location-option-label selected' : 'location-option-label'}>Country*</label>
                    </span>

                </div>
                {pageState?.invalidCountry && (
                    <div id="location-help" className="p-error block text-left">Require Country</div>
                )}
                <div className='input-item'>
                    <span className="wrapper-box">
                        <InputText id="firstname" aria-describedby="firstname-help"
                            className={classNames({ "p-invalid": pageState?.invalidFirstname })}
                            placeholder=" "
                            value={pageState.firstname}
                            onChange={(e) => {
                                setPageState({
                                    ...pageState,
                                    firstname: e.target.value,
                                    invalidFirstname: isNil(e.target.value) || e.target.value == ""
                                })
                            }}
                        />
                        <label>First Name *</label>
                    </span>
                </div>
                {pageState?.invalidFirstname && (
                    <small id="fristname-help" className="p-error block">Require Valid First Name</small>
                )}
                <div className='input-item'>
                    <span className="wrapper-box">
                        <InputText id="lastname" aria-describedby="lastname-help"
                            className={classNames({ "p-invalid": pageState?.invalidLastname })}
                            placeholder=" "
                            value={pageState.lastname}
                            onChange={(e) => {
                                setPageState({
                                    ...pageState,
                                    lastname: e.target.value,
                                    invalidLastname: isNil(e.target.value) || e.target.value == ""
                                })
                            }}
                        />
                        <label>Last Name *</label>
                    </span>
                </div>
                {pageState?.invalidLastname && (
                    <small id="lastname-help" className="p-error block">Require Valid Last Name</small>
                )}
                <div className='input-item'>
                    <span className="wrapper-box">
                        <InputText id="email" aria-describedby="email-help"
                            className={classNames({ "p-invalid": pageState?.invalidEmail })}
                            placeholder=" "
                            value={pageState.email}
                            onChange={(e) => {
                                setPageState({
                                    ...pageState,
                                    email: e.target.value,
                                    invalidEmail: isNil(e.target.value) || e.target.value == ""
                                })
                            }}
                        />
                        <label>Email *</label>
                    </span>
                </div>
                {pageState?.invalidEmail && (
                    <small id="email-help" className="p-error block">Require Valid Email</small>
                )}
                <div className='input-item'>
                    <span className="wrapper-box">
                        <InputText id="mobile" aria-describedby="mobile-help"
                            className={classNames({ "p-invalid": pageState?.invalidMobile })}
                            onKeyPress={(e: any) => IsNumberVerification(e)}
                            placeholder=" "
                            value={pageState.mobile}
                            onChange={(e) => {
                                let mobile = e.target.value.slice(0, 11);
                                setPageState({
                                    ...pageState,
                                    mobile: mobile,
                                    invalidMobile: isNil(mobile) || mobile == "" || mobile.length < 9 || mobile.length > 13
                                })
                            }}
                        />
                        <label>Mobile *</label>
                    </span>
                </div>
                {pageState?.invalidMobile && (
                    <small id="mobile-help" className="p-error block">Require Valid Mobile</small>
                )}

                <div className={`input-item textarea`}>
                    <span className="wrapper-box">
                        <InputTextarea id="comments" aria-describedby="comments-help"
                            placeholder=" "
                            ref={textAreaRef}
                            rows={8}
                            value={pageState.comments}
                            onChange={(e: any) => {
                                setPageState({
                                    ...pageState,
                                    comments: e.target.value,
                                });
                                checkOverflow();
                            }}
                        />
                        <label style={{ display: isOverflown ? "none" : '', textAlign: "left" }}>Please include any additional information or questions here</label>
                    </span>
                </div>


            </div>

            <div className='checkbox-panel'>
                <div className="section-save-ack">
                    <Checkbox
                        name="cb-ack-save"
                        inputId="cb-ack-save"
                        onChange={(e) =>
                            setPageState({
                                ...pageState,
                                checkPrivacy: e.checked,
                                invalidCheckPrivacy: !e.checked
                            })

                        }
                        checked={pageState?.checkPrivacy}
                    ></Checkbox>
                    <label htmlFor="cb-ack-save" className="p-checkbox-label">
                        I agree to Cadillac's  {' '}
                        <PrivacyPolicyLink props='Privacy Policy' />
                                &nbsp;and&nbsp;
                                <PrivacyCollectionDialog />
                    </label>
                </div>

                <div className="section-save-ack">
                    <Checkbox
                        name="cb-ack-save-optional"
                        inputId="cb-ack-save-optional"
                        onChange={(e) =>
                            setPageState({
                                ...pageState,
                                checkMarketingComms: e.checked,
                                invalidCheckMarketingComms: !e.checked
                            })
                        }
                        checked={pageState?.checkMarketingComms}
                    ></Checkbox>
                    <label htmlFor="cb-ack-save-optional" className="p-checkbox-label">
                        I consent to receiving direct marketing materials from Cadillac.
                            </label>
                </div>
            </div>

            <div className='btn-panel'>
                {submitButtonTemplate()}
            </div>
            {/*{!isNil(saveFailedMessage) && saveFailedMessage != "" && (*/}
            {/*    <div className="text-error" dangerouslySetInnerHTML={{ __html: saveFailedMessage }}></div>*/}
            {/*)}*/}
        </div>
        )

}

export default RequestACallForm